import * as React from 'react';

import {fetchPublicProductUpdates, type PublicProductUpdate} from './public-product-update-feed';

export function usePublicProductUpdatesFeed() {
    const [productUpdates, setProductUpdates] = React.useState<PublicProductUpdate[]>([]);
    const [isLoading, setIsLoading] = React.useState(true);

    React.useEffect(() => {
        let cancelled = false;

        fetchPublicProductUpdates()
            .then((updates) => {
                if (!cancelled) {
                    setProductUpdates(updates);
                }
            })
            .catch(() => {})
            .finally(() => {
                if (!cancelled) {
                    setIsLoading(false);
                }
            });

        return () => {
            cancelled = true;
        };
    }, []);

    return {
        productUpdates,
        isLoading,
    };
}
